import cn from 'classnames';
import { cva } from 'class-variance-authority';

const buttonVariants = cva('rounded-md px-4 py-2 text-sm', {
  variants: {
    variant: {
      primary: 'bg-primary text-white',
      secondary: 'bg-white border border-gray-300',
      outline: 'bg-white border border-gray-300 text-gray-700 hover:bg-gray-50',
    },
  },
});

export default function Button({
  children,
  className,
  variant = 'primary',
  type = 'button',
  onClick,
  disabled = false,
}: {
  children: React.ReactNode;
  className?: string;
  variant?: 'primary' | 'secondary' | 'outline';
  type?: 'button' | 'submit';
  onClick?: () => void;
  disabled?: boolean;
}) {
  return (
    <button
      className={cn(
        buttonVariants({ variant }),
        className,
        disabled && 'cursor-not-allowed opacity-50',
      )}
      type={type}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
}
